import { useIntl } from 'react-intl'

import { useLocalizedCountryList } from './useLocalizedCountryList'
import { BaseCountryItem } from '../../../models/user/User'

export function useLocalizedCountryListFilter<T extends BaseCountryItem>(
  countryList: T[],
  search: string,
  options?: { relabelUSWithTerritories?: boolean },
): (T & { localizedCountryName: string })[] {
  const { locale } = useIntl()
  const localizedCountryList = useLocalizedCountryList(countryList, options)

  const filtered = localizedCountryList.filter((country) => {
    const searchLowerCase = search.toLocaleLowerCase(locale)
    return country.localizedCountryName.toLocaleLowerCase(locale).startsWith(searchLowerCase)
  })

  return filtered
}
